export default __webpack_public_path__ + "static/media/ELEMENTOS_12.ce601c48.png";